import { configureDevMode, configureDevModeComponent } from '@chipinside/devmode'

import { isLocal } from '#/utils'
import { copyToClipboard } from '#/utils/copyToClipboard'

const initializeDevMode = () => {
  configureDevMode(isLocal)
  configureDevModeComponent({
    onCopy: copyToClipboard,
  })
}

export default initializeDevMode
